import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL, USER_URL } from "../../constant/api";
import { FaCloudUploadAlt, FaArrowLeft } from "react-icons/fa";
import { BsPersonFill } from "react-icons/bs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AdminProfile() {
  const [profileData, setProfileData] = useState({
    personal: {
      username: "",
      email: "",
      mobile_number: "",
    },
    company: {
      name: "",
      location: "",
      mail_id: "",
      logo: null,
    },
  });
  const [editingData, setEditingData] = useState({ ...profileData });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchProfileData();
  }, []);

  const fetchProfileData = async () => {
    try {
      const response = await USER_URL.get("/accounts/admin/profile/");
      const data = response.data.Data;
      console.log("profile", response.data);
    //   setProfileData({
    //     personal: {
    //       username: data.username || "",
    //       email: data.email || "",
    //       mobile_number: data.mobile_number || "",
    //     },
    //     company: {
    //       name: data.name || "",
    //       location: data.location || "",
    //       mail_id: data.mail_id || "",
    //       logo: data.logo || null,
    //     },
    //   });

    //   setEditingData({
    //     personal: {
    //       username: data.username || "",
    //       email: data.email || "",
    //       mobile_number: data.mobile_number || "",
    //     },
    //     company: {
    //       name: data.name || "",
    //       location: data.location || "",
    //       mail_id: data.mail_id || "",
    //       logo: data.logo || null,
    //     },
    //   });
    } catch (error) {
      console.error("Error fetching admin profile:", error);
      toast.error("Failed to fetch admin profile data");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (type, e) => {
    const { name, value } = e.target;
    setEditingData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [name]: value,
      },
    }));
  };

  const handleLogoChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      setEditingData((prev) => ({
        ...prev,
        company: {
          ...prev.company,
          logo: file,
        },
      }));
    }
  };

  const saveProfileData = async () => {
    try {
      const formData = new FormData();
      formData.append("username", editingData.personal.username);
      formData.append("email", editingData.personal.email);
      formData.append("mobile_number", editingData.personal.mobile_number);
      formData.append("name", editingData.company.name);
      formData.append("location", editingData.company.location);
      formData.append("mail_id", editingData.company.mail_id);

      if (editingData.company.logo instanceof File) {
        formData.append("logo", editingData.company.logo);
      }

      await USER_URL.patch("/accounts/admin/profile/", formData);
      toast.success("Profile updated successfully");
      fetchProfileData();
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Failed to update profile");
    }
  };

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        Loading...
      </div>
    );
  }

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-cover bg-no-repeat"
      style={{ backgroundImage: "url('/images/profile/BImage.png')" }}
    >
      <button
        onClick={() => window.history.back()}
        className="absolute left-4 top-4 rounded-full bg-white p-2 text-black shadow-md hover:bg-gray-100"
      >
        <FaArrowLeft />
      </button>

      <div className="flex w-11/12 max-w-6xl flex-col gap-5 p-4 md:flex-row">
        {/* Profile View */}
        <div className="w-full rounded-lg bg-white p-6 shadow-lg md:w-1/4">
          <h3 className="text-lg font-bold text-blue-600">Admin Details</h3>
          <div className="mb-5 mt-5 flex h-20 w-20 items-center justify-center rounded-full bg-gray-300">
            <BsPersonFill className="size-16 text-white" />
          </div>
          <div className="ml-2 text-sm font-semibold text-gray-700">
            <p>{profileData.personal.username}</p>
            <p>{profileData.personal.mobile_number}</p>
            <p>{profileData.personal.email}</p>
            <hr className="my-6" />
            <h3 className="text-lg font-bold text-blue-600">Organization</h3>
            <p>{profileData.company.name}</p>
            <p>{profileData.company.location}</p>
            <p>{profileData.company.mail_id}</p>
            {profileData.company.logo ? (
              <img
                src={
                  profileData.company.logo instanceof File
                    ? URL.createObjectURL(profileData.company.logo)
                    : `${BASE_URL}${profileData.company.logo}`
                }
                alt="Logo"
                className="mt-4 h-20 w-20 rounded-md"
              />
            ) : (
              <div className="mt-5 flex h-20 w-20 items-center justify-center rounded-md bg-gray-200">
                <span>No Logo</span>
              </div>
            )}
          </div>
        </div>

        {/* Profile Edit */}
        <div className="w-full rounded-lg bg-white p-6 shadow-lg md:w-3/4">
          <div className="space-y-10">
            {/* Personal */}
            <div>
              <h4 className="text-lg font-bold text-blue-600">Admin Info</h4>
              <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {["username", "email", "mobile_number"].map((field) => (
                  <div key={field}>
                    <label className="text-sm font-semibold capitalize">
                      {field.replace("_", " ")}
                    </label>
                    <input
                      type={field === "email" ? "email" : "text"}
                      name={field}
                      value={editingData.personal[field]}
                      onChange={(e) => handleChange("personal", e)}
                      className="w-full rounded-md border border-gray-300 p-3 text-sm"
                    />
                  </div>
                ))}
              </div>
            </div>

            Company
            <div>
              <h4 className="text-lg font-bold text-blue-600">
                Organization Info
              </h4>
              <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {["name", "location", "mail_id"].map((field) => (
                  <div key={field}>
                    <label className="text-sm font-semibold capitalize">
                      {field.replace("_", " ")}
                    </label>
                    <input
                      type={field === "mail_id" ? "email" : "text"}
                      name={field}
                      value={editingData.company[field]}
                      onChange={(e) => handleChange("company", e)}
                      className="w-full rounded-md border border-gray-300 p-3 text-sm"
                    />
                  </div>
                ))}
                <div className="flex items-center gap-5 lg:gap-16">
                  {editingData.company.logo ? (
                    <img
                      src={
                        editingData.company.logo instanceof File
                          ? URL.createObjectURL(editingData.company.logo)
                          : `${BASE_URL}${editingData.company.logo}`
                      }
                      alt="Logo"
                      className="h-16 w-16 rounded-md border object-cover"
                    />
                  ) : (
                    <div className="flex h-16 w-16 items-center justify-center rounded-md bg-gray-200">
                      <span className="text-xs">No Logo</span>
                    </div>
                  )}
                  <label className="flex cursor-pointer items-center rounded-md bg-blue-500 px-4 py-2 text-sm text-white hover:bg-blue-600">
                    <FaCloudUploadAlt className="mr-2" />
                    Upload Logo
                    <input
                      type="file"
                      onChange={handleLogoChange}
                      className="hidden"
                      accept="image/*"
                    />
                  </label>
                </div>
              </div>
            </div>

            {/* Save Button */}
            <div className="flex justify-end">
              <button
                onClick={saveProfileData}
                className="rounded-md bg-blue-500 px-6 py-2 text-sm text-white hover:bg-blue-600 sm:text-base"
              >
                Save All Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

export default AdminProfile;
